import { Package, Settings, ChevronRight, MessageSquare, FileText, HelpCircle } from "lucide-react";

const SOON = [
    { icon: MessageSquare, label: "Beskeder" },
    { icon: HelpCircle, label: "Hjælp & support" },
];

export default function MoreScreen({ onNavigate }) {
    return (
        <div className="space-y-5" data-testid="employee-more">
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Mere</h1>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm divide-y divide-slate-100 overflow-hidden" data-testid="more-menu">
                <button onClick={() => onNavigate("materialer")} data-testid="more-materialer"
                    className="w-full flex items-center gap-3 px-4 py-4 active:bg-slate-50 transition-colors">
                    <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center"><Package className="w-5 h-5 text-blue-600" /></div>
                    <span className="flex-1 text-left font-semibold text-slate-800">Materialer</span>
                    <ChevronRight className="w-5 h-5 text-slate-300" />
                </button>
                <button onClick={() => onNavigate("indstillinger")} data-testid="more-indstillinger"
                    className="w-full flex items-center gap-3 px-4 py-4 active:bg-slate-50 transition-colors">
                    <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center"><Settings className="w-5 h-5 text-blue-600" /></div>
                    <span className="flex-1 text-left font-semibold text-slate-800">Indstillinger</span>
                    <ChevronRight className="w-5 h-5 text-slate-300" />
                </button>
                <button onClick={() => onNavigate("opgaver")} data-testid="more-job-files" className="w-full flex items-center gap-3 px-4 py-4 active:bg-slate-50 transition-colors">
                    <FileText className="w-5 h-5 text-blue-600 shrink-0" /><span className="flex-1 text-left font-semibold text-slate-800">Opgavebilag og kvitteringer</span><ChevronRight className="w-5 h-5 text-slate-300 shrink-0" />
                </button>
            </div>

            <section>
                <h2 className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Kommer senere</h2>
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm divide-y divide-slate-100 overflow-hidden">
                    {SOON.map(({ icon: Icon, label }) => (
                        <div key={label} className="flex items-center gap-3 px-4 py-3.5 opacity-60">
                            <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center"><Icon className="w-5 h-5 text-slate-400" /></div>
                            <span className="flex-1 font-medium text-slate-500">{label}</span>
                            <span className="text-[11px] font-semibold text-slate-400 bg-slate-100 px-2 py-1 rounded-full">Kommer senere</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
